
 
export default {

  state: {
segmaentDetail: {
    categoryId: null, // Initially setting the id to null
    commodityId: null, // Initially setting the id to null
},
editSegmentId: null,
requestSegment: false,    

  },

  mutations: {

    // Mutation to set the ID

    setId(state, segmaentDetail ) {

      state.segmaentDetail = segmaentDetail;
      

    },
    
    setEditId(state, editSegmentId ) {

      state.editSegmentId = editSegmentId;
      
    },
    setRequestSegment(state, requestSegment ) {

      state.requestSegment = requestSegment;
      
    },

  },

  actions: {

    // Action to commit the mutation

    updateId({ commit }, segmaentDetail) {

      commit('setId', segmaentDetail);

    },
    
    updateEditId({ commit }, editSegmentId) {

      commit('setEditId', editSegmentId);

    },
    updateRequestSegment({ commit }, requestSegment) {

      commit('setRequestSegment', requestSegment);

    },

  },

  getters: {

    // Getter to access the ID

    getId(state) {

      return state.segmaentDetail;

    },
    getEditId(state) {

      return state.editSegmentId;

    },
    getRequestSegment(state) {

      return state.requestSegment;

    },

  },

};

 